import { FsCore } from 'types/fs-core'
import { createPayloadAction } from '../helpers/redux-helpers'

export const updateSmeProfile = createPayloadAction<FsCore.SmeProfile>('UPDATE_SME_PROFILE')

export const updateSmeBusinessFinanceResults = createPayloadAction<FsCore.BusinessFinanceResults>(
  'UPDATE_SME_BUSINESS_FINANCE_RESULTS',
)

export const updateAllicaResults =
  createPayloadAction<FsCore.AllicaResults>('UPDATE_ALLICA_RESULTS')
